import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { SubstructureAddButton } from "./SubstructureAddButton";
import { SubstructureContent } from "./SubstructureContent";
import { SubstructureElementLayout } from "./SubstructureElementLayout";
/**
 * Embedded sub configuration
 * @returns
 */
export function SubstructureEmbeddedContent() {
    var _a;
    const attribute = useCsAttribute();
    const substructures = (_a = attribute.configurations) !== null && _a !== void 0 ? _a : [];
    return (_jsx(SubstructureElementLayout, { addButton: _jsx(SubstructureAddButton, {}), instanceList: _jsx(Box, { children: substructures.map((substructure, idx) => (_jsx(SubstructureContent, { substructure: substructure }, idx))) }) }));
}
SubstructureEmbeddedContent.displayName = "SubstructureEmbeddedContent";
//# sourceMappingURL=SubstructureEmbeddedContent.js.map